import "./Card.scss";

import type { ButtonIconProps } from "components/ButtonIcon/ButtonIcon.tsx";
import ButtonIcon from "components/ButtonIcon/ButtonIcon.tsx";
import React from "react";

export type FutureMedicalCardProps = {
  heading: string;
  cardNumber?: number;
  children: React.ReactNode;
  style?: React.CSSProperties;
  headerButton?:
    | ({ hasButton: boolean } & Partial<ButtonIconProps>)
    | React.ReactNode;
};

const FutureMedicalCard = ({
  heading,
  children,
  headerButton,
  cardNumber,
  ...rest
}: FutureMedicalCardProps) => {
  return (
    <div
      className={`card form future-medical-card card-${cardNumber}`}
      {...rest}
    >
      {heading && (
        <div className="card__header">
          {heading}
          {headerButton &&
            (typeof headerButton === "object" && "hasButton" in headerButton ? (
              <ButtonIcon {...(headerButton as ButtonIconProps)} />
            ) : (
              headerButton
            ))}
        </div>
      )}
      <div className="card__children">{children}</div>
    </div>
  );
};

FutureMedicalCard.displayName = "Card";

export default FutureMedicalCard;
